import { IconCheck, IconCopy } from '@tabler/icons-react';
import { copyToClipboard } from '@xver/utils/clipboard';
import { useEffect, useState } from 'react';

interface CopyButtonProps {
    value: string;
    ariaLabel: string;
}

export default function CopyButton({ value, ariaLabel }: CopyButtonProps) {
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!copied) return;
        const timeoutId = window.setTimeout(() => setCopied(false), 1500);
        return () => window.clearTimeout(timeoutId);
    }, [copied]);

    return (
        <button
            type="button"
            aria-label={ariaLabel}
            title={ariaLabel}
            onClick={async (e) => {
                e.stopPropagation();
                await copyToClipboard(value);
                setCopied(true);
            }}
            className="inline-flex shrink-0 cursor-pointer items-center justify-center rounded-md border border-line bg-surface-2 px-2 py-1 text-fg/68 transition-colors hover:bg-surface-3 hover:text-fg"
        >
            {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
        </button>
    );
}
